import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    registrationId: String,
    refreshUrl: String,
    refreshingText: String,
    refreshButtonText: String
  }

  static targets = ["integrationsList", "refreshButton"]

  connect() {
    console.log("Integration polling controller connected")
    // Store original button text
    if (this.hasRefreshButtonTarget) {
      this.originalButtonHtml = this.refreshButtonTarget.innerHTML
    }
  }

  disconnect() {
    console.log("Integration polling controller disconnected")
  }

  // Manual refresh - fetch only the integrations list partial
  async refresh() {
    console.log("Refreshing integrations status...")

    // Disable button during refresh
    if (this.hasRefreshButtonTarget) {
      this.refreshButtonTarget.disabled = true
      const refreshingText = this.hasRefreshingTextValue ? this.refreshingTextValue : 'Refreshing...'
      this.refreshButtonTarget.innerHTML = `<span class="spinner-border spinner-border-sm me-1"></span> ${refreshingText}`
    }

    try {
      const response = await fetch(this.refreshUrlValue, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        if (this.hasIntegrationsListTarget) {
          this.integrationsListTarget.innerHTML = html
        }
        console.log("Integrations status refreshed successfully")
      } else {
        console.error("Failed to refresh integrations status")
      }
    } catch (error) {
      console.error("Error refreshing integrations:", error)
    } finally {
      // Re-enable button with original text
      if (this.hasRefreshButtonTarget) {
        this.refreshButtonTarget.disabled = false
        this.refreshButtonTarget.innerHTML = this.originalButtonHtml
      }
    }
  }
}

